import * as tslib_1 from "tslib";
import { OnInit, } from '@angular/core';
import { FormBuilder, Validators, } from '@angular/forms';
import { AppStateFacade } from '@app-state';
import { UiModalComponent } from '@components/ui-modal/ui-modal.component';
import { FeatureFlag, FolderType, } from '@models';
import { MAX_NUMBER_OF_RESULTS } from '@pages/shared/constants';
import { EnvironmentService, PackageService, ProcessService, } from '@services';
import UiValidators, { UI_DESCRIPTION_MAX_LENGTH } from '@validators';
import cloneDeep from 'lodash-es/cloneDeep';
import { BehaviorSubject, } from 'rxjs';
import { finalize, map, share, tap, } from 'rxjs/operators';
import { ProcessSettingsComponent } from '../../shared';
var ProcessModalComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ProcessModalComponent, _super);
    function ProcessModalComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading$ = new BehaviorSubject(false);
        _this._processService = _this._injector.get(ProcessService);
        _this._environmentService = _this._injector.get(EnvironmentService);
        _this._packageService = _this._injector.get(PackageService);
        _this._appState = _this._injector.get(AppStateFacade);
        _this.processSearchFactory = function (query, top, skip) {
            if (query === void 0) { query = ''; }
            if (top === void 0) { top = MAX_NUMBER_OF_RESULTS; }
            if (skip === void 0) { skip = 0; }
            var queryOptions = {
                orderBy: ['Id'],
                filter: {
                    Id: {
                        contains: query,
                    },
                },
                skip: skip,
                top: top,
            };
            return _this._packageService
                .get(queryOptions)
                .pipe(map(function (response) { return ({
                data: _this._mapProcesses(response.data),
                total: response.total,
            }); }));
        };
        _this.environmentSearchFactory = function (query, step, skip) {
            if (query === void 0) { query = ''; }
            if (step === void 0) { step = MAX_NUMBER_OF_RESULTS; }
            if (skip === void 0) { skip = 0; }
            var queryOptions = {
                orderBy: ['Name'],
                skip: skip,
                filter: {
                    Name: {
                        contains: query,
                    },
                },
                top: step,
            };
            return _this._environmentService
                .get(queryOptions)
                .pipe(map(function (response) { return ({
                data: _this._mapEnvironments(response.data),
                total: response.total,
            }); }));
        };
        _this._mapPackages = function (packages) {
            return packages
                .map(function (pkg) {
                return {
                    id: pkg.key,
                    text: pkg.version,
                    data: pkg,
                };
            });
        };
        _this._mapProcesses = function (processes) {
            return processes.map(function (process) {
                return {
                    id: process.id,
                    text: process.id,
                };
            });
        };
        _this._mapEnvironments = function (environments) {
            return environments.map(function (environment) {
                return {
                    id: environment.id,
                    text: environment.name,
                };
            });
        };
        return _this;
    }
    Object.defineProperty(ProcessModalComponent.prototype, "selectedProcess", {
        get: function () {
            return this.context.data.processKey ?
                {
                    id: this.context.data.processKey,
                    text: this.context.data.processKey,
                } :
                null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProcessModalComponent.prototype, "isProcessSettingEnabled", {
        get: function () {
            return this._appState.settings.isFeatureEnabled(FeatureFlag.MediaRecording) ||
                this._appState.settings.isFeatureEnabled(FeatureFlag.ProcessSettingAutoStart);
        },
        enumerable: true,
        configurable: true
    });
    ProcessModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isCurrentFolderClassic$ = this._appState.user.folder.isClassic$;
        this.form = this._injector.get(FormBuilder).group({
            'processKey': [
                [this.selectedProcess],
                UiValidators.required(),
            ],
            'processVersion': [
                [], function (c) {
                    return _this.selectedProcess == null ?
                        null :
                        UiValidators.required()(c);
                }
            ],
            'description': [
                '',
                Validators.maxLength(UI_DESCRIPTION_MAX_LENGTH)
            ],
            'environment': [
                null,
                this._appState.user.folder.type === FolderType.Classic ? UiValidators.required() : [],
            ],
            'arguments': [
                {},
            ],
        });
    };
    ProcessModalComponent.prototype.fetchPackages = function () {
        var _this = this;
        var queryOptions = {
            orderBy: ['Version desc'],
        };
        this.packages$ = this._packageService
            .getVersions(this.context.data.processKey, queryOptions)
            .pipe(map(function (result) {
            return !result || !result.total ?
                [] :
                _this._mapPackages(result.data);
        }), tap(function (packages) {
            if (packages &&
                packages.length > 0) {
                _this.form.patchValue({ 'processVersion': [packages[0]] });
                _this.onVersionSelect(packages[0]);
            }
            else {
                // TODO: Refactor to prevent code duplication
                _this.form.patchValue({ 'processVersion': [] });
                _this.form.get('arguments').patchValue({});
                _this.args = undefined;
            }
        }), share());
    };
    ProcessModalComponent.prototype.onSubmit = function (_ev) {
        var _this = this;
        var isScreenRecordingInvalid = this.processSetting && this.processSetting.form.invalid;
        if (this.form.invalid ||
            isScreenRecordingInvalid ||
            this.loading$.value) {
            return;
        }
        this.loading$.next(true);
        var payload = cloneDeep(this.context.data);
        payload.description = this.form.get('description').value;
        payload.name = this._appState.user.folder.type === FolderType.Classic
            ? this.context.data.processKey + "_" + this.context.data.environmentName
            : this.context.data.processKey;
        payload.inputArguments = this.form.get('arguments').value;
        if (this.isProcessSettingEnabled &&
            this.processSetting) {
            payload.processSettings = this.processSetting.form.value;
        }
        this._processService.add(payload)
            .pipe(finalize(function () { return _this.loading$.next(false); }))
            .subscribe(function () {
            return _this._dialogRef.close({
                type: 1 /* Add */,
            });
        });
    };
    ProcessModalComponent.prototype.onVersionSelect = function (_a) {
        var data = _a.data;
        this.context.data.processVersion = data.version;
        this.form.get('arguments').patchValue({});
        this.args = data.arguments;
    };
    return ProcessModalComponent;
}(UiModalComponent));
export { ProcessModalComponent };
